import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { entitiesUpdated } from './entitiesUpdated';

export const outputActions = [entitiesUpdated];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
